/**
 * Центральный файл конфигурации скоупов, бейджей и иерархии ролей.
 * 
 * Внимание: данный файл является точкой обратной совместимости (реэкспорт).
 * Исходные конфигурации разделены по модулям:
 * - ./scopes/           - скоупы прав по модулям (users, createAccount, reports, documents, journal)
 * - ./badgePresets.ts   - цветовые палитры бейджей
 * - ./hierarchy.ts      - градации рангов и функция getHierarchyInfo
 */

export * from './scopes';
export * from './badgePresets';
export * from './hierarchy';
